import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ToggleButton from "../../ToggleButton";

const EditarCasaExclusiva = ({
    producto,
    setProducto,
    setModal,
    tipo_producto,
}) => {
    const [toggleButton, setToggleButton] = useState(
        producto.data?.landing_exclusiva === "Si" ? true : false
    );
    const [toggleButtonCarrusel, setToggleButtonCarrusel] = useState(
        producto.data?.carrusel_home === "Si" ? true : false
    );
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("token");
    const headers = {
        authorization: token,
    };

    const handleGuardar = async () => {
        setLoading(true);
        console.log("handleGuardar");
        try {
            const json = await axios.put(
                `${process.env.REACT_APP_PROXY}/${
                    producto.data.tipo_producto !== "embarcacion"
                        ? "casa"
                        : "embarcacion"
                }/${
                    producto.data.tipo_producto !== "embarcacion"
                        ? "updateTipoReserva"
                        : "updateTipoReservaEmbarcacion"
                }/${producto.data.id}`,
                {
                    tipo_reserva: toggleButton ? "calendario" : "formulario",
                },

                { headers }
            );

            if (json.data.message === "actualizado con exito") {
                setProducto({
                    ...producto,
                    data: {
                        ...producto.data,
                        landing_exclusiva: toggleButton ? "Si" : "No",
                        carrusel_home:
                            toggleButton === false
                                ? "No"
                                : toggleButtonCarrusel
                                ? "Si"
                                : "No",
                    },
                });
                setLoading(false);
                setModal(false);
                Swal.fire({
                    icon: "success",
                    title: "Casa actualizada",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        } catch (error) {
            setLoading(false);

            Swal.fire({
                icon: "error",
                title: "Error al editar Landing exclusivo   ",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    };

    return (
        <div className="p-4 border rounded-lg">
            <div>
                <div>
                    <div className="flex items-center justify-between w-full">
                        <h1>Casa exclusiva</h1>

                        <div className="flex items-center gap-2">
                            <p className="">No</p>

                            <ToggleButton
                                isToggled={toggleButton}
                                onChangeToggle={(e) => setToggleButton(e)}
                            />
                            <p className="">Si</p>
                        </div>
                    </div>
                    <div></div>
                </div>
                {toggleButton && (
                    <div className="mt-2">
                        <div className="flex items-center justify-between w-full">
                            <h1>Casa en carrusel home</h1>

                            <div className="flex items-center gap-2">
                                <p className="">No</p>

                                <ToggleButton
                                    isToggled={toggleButtonCarrusel}
                                    onChangeToggle={(e) =>
                                        setToggleButtonCarrusel(e)
                                    }
                                />
                                <p className="">Si</p>
                            </div>
                        </div>
                        <div></div>
                    </div>
                )}
            </div>
            <div className="flex justify-end">
                <button
                    disabled={loading}
                    onClick={() => handleGuardar()}
                    className="p-3 my-6 border rounded-lg border-blue-bluecorner text-blue-bluecorner px-7">
                    {loading ? "Cargando..." : "Guardar"}
                </button>
            </div>
        </div>
    );
};

export default EditarCasaExclusiva;
